import React from "react";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";

const ModalInputText = (props) => {
  return (
    <Form.Group className="mb-3" controlId={props.Name}>
      <Form.Label>{props.Label}</Form.Label>
      <Form.Control
        type="password"
        name={props.Name}
        value={props.Val}
        onChange={(e) => props.thischange(e.target.value)}
        onBlur={props.theAction}
        readOnly={props.readonly}
        style={
          props.error
            ? { backgroundColor: "Red", boxShadow: "5px 5px #b1b1b1" }
            : { backgroundColor: "White", boxShadow: "5px 5px #b1b1b1" }
        }
      />
    </Form.Group>
  );
};

export default ModalInputText;
